module.exports = __webpack_public_path__ + "static/media/image-2.86947c34.jpg";